import Swiper, {Autoplay, Pagination} from 'swiper';

export class BoxesComponent {
  containerName = '';

  container = null;

  swiper = null;

  config = {
    slidesPerView: 'auto',
    spaceBetween: 14,
    autoplay: {
      delay: 5000
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    }
  };

  constructor(containerName = '') {

  }

  addEventListeners() {
    window.addEventListener('resize', (e) => this.windowResizeHandler(e));
  }

  initialize() {
    const container = document.querySelector(`.${this.containerName}`);
    if (!container) {
      return;
    }

    this.container = container;

    Swiper.use([Autoplay, Pagination]);

    if (window.innerWidth <= 768) {
      this.createSlider();
    }
  }

  windowResizeHandler(e) {
    window.innerWidth > 768
      ? this.destroySlider()
      : this.createSlider();
  }

  createSlider() {
    if (this.swiper) {
      return;
    }

    const container = this.container;
    if (!container) {
      return;
    }

    container.classList.add('swiper-container');

    const wrapper = container.querySelector('.elementor-container');
    if (!wrapper) {
      return;
    }

    wrapper.classList.add('swiper-wrapper');

    const items = wrapper.getElementsByClassName(`${this.containerName}__item`);
    if (items.length) {
      Array.from(items).forEach((item) => {
        item.classList.add('swiper-slide');
      });
    }

    const pagination = document.createElement('div');
    pagination.classList.add('swiper-pagination');

    container.appendChild(pagination);

    const swiper = new Swiper(container, this.config);

    this.swiper = swiper;
  }

  destroySlider() {
    const swiper = this.swiper;
    if (!swiper) {
      return;
    }

    const container = this.container;
    if (!container) {
      return;
    }

    container.classList.remove('swiper-container');

    const wrapper = container.querySelector('.elementor-container');
    if (!wrapper) {
      return;
    }

    wrapper.classList.remove('swiper-wrapper');

    const items = wrapper.getElementsByClassName(`${this.containerName}__item`);
    if (items.length) {
      Array.from(items).forEach((item) => {
        item.classList.remove('swiper-slide');
      });
    }

    const pagination = container.querySelector('.swiper-pagination');
    if (pagination) {
      pagination.remove();
    }

    swiper.destroy();
    this.swiper = null;
  }
}